// Lazy load videos in scrolling cards section
(function() {
  function initLazyVideos() {
    const videos = document.querySelectorAll('.scrolling-card-video[data-video-src]');
    
    if (!videos.length) return;
    
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const video = entry.target;
            const source = video.querySelector('source[data-src]');
            const poster = video.parentElement.querySelector('.scrolling-card-poster');
            
            if (source && source.dataset.src) {
              source.src = source.dataset.src;
              video.load();
              video.style.display = 'block';
              if (poster) poster.style.display = 'none';
            }
            
            observer.unobserve(video);
          }
        });
      }, {
        rootMargin: '50px',
        threshold: 0.01
      });
      
      videos.forEach(video => observer.observe(video));
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLazyVideos);
  } else {
    initLazyVideos();
  }
})();
